<template>
  <div>
    <breadcrumbs home="Settings"/>

    <v-card flat>
      <v-tabs show-arrows v-model="tab" @change="changeTab(true)">
        <v-tab :disabled="company.status==='Inactive'">Distillery</v-tab>
        <v-tab>Account</v-tab>
        <v-tab>Billing history</v-tab>
        <v-tab :disabled="company.status==='Inactive'">Preferences</v-tab>
        <v-tab :disabled="company.status==='Inactive'">Sites / Licenses</v-tab>
        <v-tab :disabled="company.status==='Inactive'">Users</v-tab>
        <v-tab :disabled="company.status==='Inactive'" v-if="company.settings.multiCurrency">Currencies</v-tab>
      </v-tabs>

      <v-tabs-items v-model="currentTab">
        <v-tab-item>
          <settings-distillery @dirty="dirty = $event" ref="distillery"/>
        </v-tab-item>

        <v-tab-item>
          <settings-account @dirty="dirty = $event" ref="account"/>
        </v-tab-item>

        <v-tab-item>
          <settings-billing-history @dirty="dirty = $event" ref="history"/>
        </v-tab-item>

        <v-tab-item>
          <settings-preferences @dirty="dirty = $event" ref="preferences"/>
        </v-tab-item>

        <v-tab-item>
          <settings-sites @dirty="dirty = $event" ref="sites"/>
        </v-tab-item>

        <v-tab-item>
          <settings-users @dirty="dirty = $event" ref="users"/>
        </v-tab-item>

        <v-tab-item v-if="company.settings.multiCurrency">
          <settings-currencies @dirty="dirty = $event" ref="currencies"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <confirm-leave v-model="next"/>
    <v-dialog v-model="confirmTabLeave" persistent max-width="350">
      <v-card>
        <v-card-title>Leave</v-card-title>
        <v-divider/>
        <v-card-text class="mt-4">You have unsaved changes that will be lost. Are you sure you want to leave?".</v-card-text>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer></v-spacer>
          <v-btn plain color="primary" @click="performLeaveTab(true)">Yes</v-btn>
          <v-btn color="primary" @click="performLeaveTab(false)">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import confirmLeave from '@/mixins/confirmLeave'
import SettingsDistillery from './SettingsDistillery.vue';
import SettingsAccount from './SettingsAccount.vue';
import SettingsBillingHistory from './SettingsBillingHistory.vue';
import SettingsPreferences from './SettingsPreferences.vue';
import SettingsSites from './SettingsSites.vue';
import SettingsUsers from './SettingsUsers.vue';
import SettingsCurrencies from './SettingsCurrencies.vue';

export default {
  name: 'Settings',
  components: {SettingsDistillery,SettingsAccount,SettingsBillingHistory,SettingsPreferences,SettingsSites,SettingsUsers,SettingsCurrencies},
  mixins: [confirmLeave],
  props: {
    initialTab: {type:[Number,String], required:false, default:0}
  },
  data() {
    return {
      tab: parseInt(this.initialTab),
      currentTab: parseInt(this.initialTab),
      dirty: false,
      confirmTabLeave: false
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    permissions() {
      return this.company.permissions;
    }
  },
  watch: {
    initialTab() {
      this.tab = parseInt(this.initialTab);
      this.changeTab(false);
    }
  },
  methods: {
    initTab(replace) {
      this.currentTab = this.tab;
      if (replace) {
        this.$router.replace({params: {initialTab:this.currentTab}});
        this.$route.params.currentTab = this.currentTab;
      }
      const tabRef = ['distillery','account','history','preferences','sites','users','currencies'][this.currentTab];
      const component = this.$refs[tabRef];
      if (component)
        component.load();
    },
    changeTab(replace) {
      if (this.dirty)
        this.confirmTabLeave = true;
      else
        this.initTab(replace);
    },
    performLeaveTab(leave) {
      this.confirmTabLeave = false;
      if (leave) {
        this.dirty = false;
        this.initTab(true);
      }
      else
        this.tab = this.currentTab;
    }
  }
}
</script>